export default [
  {
    path: '/employee-daily-timescans',
    name: 'employee-daily-timescan',
    meta: { requiresAuth: true },
    component: () => import('@/pages/employee-daily-timescan/index.vue')
  }
]
